import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AllCompaniesState, Company } from "./interfaces";

const initialState: AllCompaniesState = {
  insurance: {
    isLoading: false,
    companies: null,
    error: null,
  },
  bank: {
    isLoading: false,
    companies: null,
    error: null,
  },
  leasing: {
    isLoading: false,
    companies: null,
    error: null,
  },
};

const companiesSlice = createSlice({
  name: "retrieveCompanies",
  initialState,
  reducers: {
    fetchInsuranceCompaniesStart: (state: AllCompaniesState) => {
      const { insurance } = state;
      insurance.isLoading = true;
    },
    fetchBankCompaniesStart: (state: AllCompaniesState) => {
      const { bank } = state;
      bank.isLoading = true;
    },
    fetchLeasingCompaniesStart: (state: AllCompaniesState) => {
      const { leasing } = state;
      leasing.isLoading = true;
    },

    fetchInsuranceCompaniesSucceeded: (
      state: AllCompaniesState,
      action: PayloadAction<Company[]>,
    ) => {
      const { insurance } = state;
      const { payload } = action;
      insurance.companies = payload;
      insurance.isLoading = false;
      insurance.error = null;
    },
    fetchBankCompaniesSucceeded: (
      state: AllCompaniesState,
      action: PayloadAction<Company[]>,
    ) => {
      const { bank } = state;
      const { payload } = action;
      bank.companies = payload;
      bank.isLoading = false;
      bank.error = null;
    },
    fetchLeasingCompaniesSucceeded: (
      state: AllCompaniesState,
      action: PayloadAction<Company[]>,
    ) => {
      const { leasing } = state;
      const { payload } = action;
      leasing.companies = payload;
      leasing.isLoading = false;
      leasing.error = null;
    },

    insuranceOperationFailed: (
      state: AllCompaniesState,
      action: PayloadAction<string>,
    ) => {
      const { insurance } = state;
      const { payload } = action;
      insurance.error = payload;
      insurance.isLoading = false;
    },
    bankOperationFailed: (
      state: AllCompaniesState,
      action: PayloadAction<string>,
    ) => {
      const { bank } = state;
      const { payload } = action;
      bank.error = payload;
      bank.isLoading = false;
    },
    leasingOperationFailed: (
      state: AllCompaniesState,
      action: PayloadAction<string>,
    ) => {
      const { leasing } = state;
      const { payload } = action;
      leasing.error = payload;
      leasing.isLoading = false;
    },
  },
});

export const {
  fetchInsuranceCompaniesStart,
  fetchBankCompaniesStart,
  fetchLeasingCompaniesStart,
  fetchInsuranceCompaniesSucceeded,
  fetchBankCompaniesSucceeded,
  fetchLeasingCompaniesSucceeded,
  insuranceOperationFailed,
  bankOperationFailed,
  leasingOperationFailed,
} = companiesSlice.actions;
export const companies = companiesSlice.reducer;
